import { render, staticRenderFns } from "./case-files-manager.vue?vue&type=template&id=26f51546&scoped=true"
import script from "./case-files-manager.vue?vue&type=script&lang=js"
export * from "./case-files-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f51546",
  null
  
)

export default component.exports